import { useQuery } from "@tanstack/react-query";
import { api } from "@/lib/api";

export type FollowKind = "agent" | "job" | "skill" | "topic";
export type DiscoveryFollow = {
  id: string;
  kind: FollowKind;
  targetKey: string;
  lastReadAt: string;
};

export function followPath(kind: FollowKind, targetKey: string) {
  return `/discovery/follows/${kind}/${encodeURIComponent(targetKey)}`;
}

export function useDiscoveryFollows(userId?: string) {
  return useQuery<DiscoveryFollow[]>({
    queryKey: ["discovery-follows", userId],
    enabled: !!userId,
    staleTime: 30_000,
    queryFn: async () => {
      const items: DiscoveryFollow[] = [];
      let cursor: string | undefined;
      // The service permits at most 100 follows per identity.
      for (let page = 0; page < 2; page++) {
        const response = (
          await api.get("/discovery/follows", {
            params: { limit: 50, cursor },
          })
        ).data;
        items.push(...response.data);
        cursor = response.meta.nextCursor || undefined;
        if (!cursor) break;
      }
      return items;
    },
  });
}
